import { Component } from '@angular/core';
import { RxFormBuilder, RxFormGroup } from '@rxweb/reactive-form-validators';
import { ConfirmationService, MessageService } from 'primeng/api';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { firstValueFrom } from 'rxjs';
import { FormValidatorService } from 'src/app/core/services/form-validator.service';
import { GroupUsersService } from 'src/app/modules/groups/_services/groups-users.service';
import { GroupsService } from 'src/app/modules/groups/_services/groups.service';
import { GroupUser } from 'src/app/modules/groups/_types/group-user';
import { LoginService } from 'src/app/modules/login/login.service';

@Component({
    selector: 'app-user-group',
    templateUrl: './user-group.component.html',
    styleUrls: ['./user-group.component.scss'],
    standalone: false
})
export class UserGroupComponent {
  public userGroupFormGroup!: RxFormGroup;

  public userGroup: GroupUser = new GroupUser();
  public groups: any[] = [];

  public allowWrite: boolean = false;
  public allowDelete: boolean = false;


  constructor(
    private groupUsersService: GroupUsersService,
    private config: DynamicDialogConfig,
    private messageService: MessageService,
    private dynamicDialogRef: DynamicDialogRef,
    private confirmationService: ConfirmationService,
    private formBuilder: RxFormBuilder,
    private formValidationService: FormValidatorService,
    private groupsService: GroupsService,
    private loginService: LoginService
  ) {
    this.userGroupFormGroup = this.formBuilder.formGroup<GroupUser>(this.userGroup) as RxFormGroup;
  }

  ngOnInit(): void {
    this.userGroup.userId = this.config.data.userId;
    this.loadGroups();

    this.allowWrite = this.loginService.hasPermission("USERS.WRITE");
    this.allowDelete = this.loginService.hasPermission("USERS.DELETE");
  }


  async loadGroups() {
    let response = await firstValueFrom(this.groupsService.all());
    let existentGroups = this.config.data.existentGroups;

    this.groups = response.data;
    this.groups = this.groups.filter((group: any) => {
      return !existentGroups.some((existentGroup: any) => existentGroup.group.id === group.id);
    });
  }


  async save() {
    let valid = this.formValidationService.validateForm(this.userGroupFormGroup);

    if (valid) {
      this.userGroup = Object.assign(this.userGroup, this.userGroupFormGroup.value);

      await this.groupUsersService.save(this.userGroup).subscribe({
        next: () => {
          this.messageService.add({ severity: 'success', summary: 'Éxito', detail: 'Grupo asignado correctamente' });
          this.dynamicDialogRef.close();
        },
        error: () => {
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error al asignar el grupo' });
        }
      });
    } else {
      document.getElementById('form')?.classList.add('formInvalid');
    }
  }
  cancel() {
    this.dynamicDialogRef.close();
  }
}
